module.exports = __webpack_public_path__ + "assets/45b4bed8f5ced11780922e7cf2c64a07.png";